import { render, staticRenderFns } from "./examinereportrectify-form.vue?vue&type=template&id=4871056c&"
import script from "./examinereportrectify-form.vue?vue&type=script&lang=js&"
export * from "./examinereportrectify-form.vue?vue&type=script&lang=js&"
import style0 from "./examinereportrectify-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports